import { BUILDINGS } from "@/modules/building/routes";

export const ReferentialType = {
  ENERGY: "DWEQEN",
  DWELLING_CATEGORY: "DWECAT",
  DWELLING_CONSTRUCTION_PERIOD: "DWECP",
  DWELLING_TYPE: "DWETYP",
  DWELLING_TYPE_PROMISE: "DWEPTY",
  DWELLING_CONDITION: "DWECON",
  FILE_TYPE: "FILETY",
  TEAM_MEMBER_AVAILABILITY: "TMART",
  LESSOR_DESIGNATION: "LESDES",
};

export const ReferentialDwellingCategory = {
  APARTMENT: "APT",
  GARAGE: "GARA",
  HOUSE: "HOUS",
  PREMISE: "PREMI",
  BUILDING: "BUILD",
};
